youbora.registerAdapter('SmartAdServer', require('./adapter'))
module.exports = youbora
